import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function EssenceSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 md:py-32 bg-cream text-charcoal-900 relative overflow-hidden bg-grain" data-id="element-48">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-49">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0 items-center" data-id="element-50">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1
        }} className="lg:col-span-7 lg:pr-16 relative z-10" data-id="element-51">
            <div className="flex items-center gap-4 mb-8" data-id="element-52">
              <div className="w-8 h-[1px] bg-gold" data-id="element-53"></div>
              <span className="text-sm tracking-[0.2em] uppercase text-gold font-semibold" data-id="element-54">
                {t.essence.label}
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading leading-tight mb-8" data-id="element-55">
              {t.essence.heading1} <br data-id="element-56" />
              <span className="italic text-charcoal-800" data-id="element-57">
                {t.essence.heading2}
              </span>
            </h2>

            <div className="space-y-6 text-lg md:text-xl text-charcoal-800/80 leading-relaxed font-light" data-id="element-58">
              <p data-id="element-59">{t.essence.p1}</p>
              <p data-id="element-60">{t.essence.p2}</p>
            </div>

            <div className="mt-12 w-full max-w-md h-[1px] bg-charcoal-900/10 relative" data-id="element-61">
              <div className="absolute left-0 top-0 w-1/3 h-[1px] bg-gold" data-id="element-62"></div>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="lg:col-span-5 relative" data-id="element-63">
            <div className="aspect-[4/5] relative overflow-hidden" data-id="element-64">
              <img src="https://cdn.magicpatterns.com/uploads/cHJ8gKjKkL8mDqjrSacnd6/IMG_4494.jpg" alt="Historický pokoj s lustrem a zlatými závěsy" className="object-cover w-full h-full hover:scale-105 transition-transform duration-1000" data-id="element-65" />
              {/* Decorative border */}
              <div className="absolute inset-4 border border-cream/30 z-10 pointer-events-none" data-id="element-66"></div>
            </div>

            {/* Offset decorative block */}
            <div className="absolute -bottom-8 -left-8 w-48 h-48 bg-charcoal-900 -z-10 hidden md:block" data-id="element-67"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}